import { Card, CardContent, CardHeader, Grid } from '@mui/material';

import { VALIDATION_RULES } from '@localstack/services';

import { ControlledCountryAutocomplete, ControlledPhoneField, ControlledTextField } from '../../../../form';

export const AddressElement = ({ isNotPriceless }: { isNotPriceless: boolean }): JSX.Element => {
  return (
    <Card>
      <CardHeader title="Billing Address" />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ControlledPhoneField
              key={`phone-${isNotPriceless}`}
              shouldUnregister
              required={isNotPriceless}
              name="phone"
              label="Primary Phone"
              placeholder="Primary Phone"
              fullWidth
              variant="outlined"
              rules={isNotPriceless ? VALIDATION_RULES.phoneRequired : VALIDATION_RULES.phone}
            />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField
              key={`email-${isNotPriceless}`}
              shouldUnregister
              required={isNotPriceless}
              name="email"
              label="Billing Email"
              placeholder="Billing Email"
              fullWidth
              variant="outlined"
              rules={VALIDATION_RULES.email}
            />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField
              key={`address-${isNotPriceless}`}
              shouldUnregister
              required={isNotPriceless}
              name="address"
              label="Address"
              placeholder="Address"
              fullWidth
              variant="outlined"
              rules={isNotPriceless ? VALIDATION_RULES.safeStringRequired : VALIDATION_RULES.safeStringOptional}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ControlledTextField
              key={`city-${isNotPriceless}`}
              shouldUnregister
              required={isNotPriceless}
              name="city"
              label="City"
              placeholder="City"
              fullWidth
              variant="outlined"
              rules={isNotPriceless ? VALIDATION_RULES.safeStringRequired : VALIDATION_RULES.safeStringOptional}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ControlledTextField
              name="state"
              label="State"
              placeholder="State"
              fullWidth
              variant="outlined"
              rules={VALIDATION_RULES.safeStringOptional}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ControlledTextField
              key={`zip-${isNotPriceless}`}
              shouldUnregister
              required={isNotPriceless}
              name="zip"
              label="Zip"
              placeholder="Zip"
              fullWidth
              variant="outlined"
              rules={{
                ...(isNotPriceless ? VALIDATION_RULES.safeStringRequired : VALIDATION_RULES.safeStringOptional),
                ...VALIDATION_RULES.zipCode,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <ControlledCountryAutocomplete
              shouldUnregister
              key={`country-${isNotPriceless}`}
              name="country"
              rules={isNotPriceless ? VALIDATION_RULES.required : undefined}
              inputProps={{
                label: 'Country',
                required: isNotPriceless,
                placeholder: 'Country',
                fullWidth: true,
                variant: 'outlined',
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
